import {
	FETCH_POSTS,
	FETCH_POST,
	UPDATE_POST,
	DELETE_POST,
	CLEAR_POSTS,
	CLEAR_POST,
} from '../actions/actionTypes';

const preState = {
	posts: [],
	post: {},
};

export const postsReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, posts, post, postID } = action;

	switch (type) {
		case FETCH_POSTS:
			return { ...stateDup, posts: [...posts.nodes] };
		case FETCH_POST:
			return { ...stateDup, post };
		case UPDATE_POST:
			const { id } = post;
			const updatedList = stateDup.posts.map(p => (id === p.id ? { ...p, ...post } : p));
			return { ...stateDup, posts: updatedList };
		case DELETE_POST:
			if (stateDup.post.id === postID) stateDup.post = {};
			stateDup.posts = stateDup.posts.filter(post => post.id !== postID);
			return stateDup;
		case CLEAR_POSTS:
			return preState;
		case CLEAR_POST:
			return { ...stateDup, post: {} };
		default:
			return state;
	}
};

export default postsReducer;
